/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * mint/v1/credit_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  RpcStatus,
  V1CreditBalance,
  V1InfuseCreditsRequest,
  V1TotalInfusedCredits,
} from '../models';

/**
 * @summary GetCreditBalance returns the current credit balance for an Organization.
 */
export const getCreditBalance = (
  organization: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CreditBalance>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/creditBalance`,
    options,
  );
};

export const getGetCreditBalanceQueryKey = (organization?: string) => {
  return [`/api/v1/organizations/${organization}/creditBalance`] as const;
};

export const getGetCreditBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getCreditBalance>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditBalance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCreditBalanceQueryKey(organization);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCreditBalance>>
  > = ({ signal }) =>
    getCreditBalance(organization, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCreditBalance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCreditBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCreditBalance>>
>;
export type GetCreditBalanceQueryError = AxiosError<RpcStatus>;

export function useGetCreditBalance<
  TData = Awaited<ReturnType<typeof getCreditBalance>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditBalance>>,
          TError,
          Awaited<ReturnType<typeof getCreditBalance>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCreditBalance<
  TData = Awaited<ReturnType<typeof getCreditBalance>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditBalance>>,
          TError,
          Awaited<ReturnType<typeof getCreditBalance>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCreditBalance<
  TData = Awaited<ReturnType<typeof getCreditBalance>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditBalance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GetCreditBalance returns the current credit balance for an Organization.
 */

export function useGetCreditBalance<
  TData = Awaited<ReturnType<typeof getCreditBalance>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditBalance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCreditBalanceQueryOptions(organization, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary GetTotalInfusedCredits returns the cumulative total of all credits ever
infused into an Organization, regardless of spending or current balance.
 */
export const getTotalInfusedCredits = (
  organization: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1TotalInfusedCredits>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/totalInfusedCredits`,
    options,
  );
};

export const getGetTotalInfusedCreditsQueryKey = (organization?: string) => {
  return [`/api/v1/organizations/${organization}/totalInfusedCredits`] as const;
};

export const getGetTotalInfusedCreditsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTotalInfusedCredits>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalInfusedCredits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTotalInfusedCreditsQueryKey(organization);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTotalInfusedCredits>>
  > = ({ signal }) =>
    getTotalInfusedCredits(organization, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organization,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTotalInfusedCredits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTotalInfusedCreditsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTotalInfusedCredits>>
>;
export type GetTotalInfusedCreditsQueryError = AxiosError<RpcStatus>;

export function useGetTotalInfusedCredits<
  TData = Awaited<ReturnType<typeof getTotalInfusedCredits>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalInfusedCredits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalInfusedCredits>>,
          TError,
          Awaited<ReturnType<typeof getTotalInfusedCredits>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTotalInfusedCredits<
  TData = Awaited<ReturnType<typeof getTotalInfusedCredits>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalInfusedCredits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTotalInfusedCredits>>,
          TError,
          Awaited<ReturnType<typeof getTotalInfusedCredits>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTotalInfusedCredits<
  TData = Awaited<ReturnType<typeof getTotalInfusedCredits>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalInfusedCredits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GetTotalInfusedCredits returns the cumulative total of all credits ever
infused into an Organization, regardless of spending or current balance.
 */

export function useGetTotalInfusedCredits<
  TData = Awaited<ReturnType<typeof getTotalInfusedCredits>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTotalInfusedCredits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTotalInfusedCreditsQueryOptions(
    organization,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary InfuseCredits adds credits to an Organization's balance.
Used when a customer purchases additional capacity.
 */
export const infuseCredits = (
  v1InfuseCreditsRequest: V1InfuseCreditsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CreditBalance>> => {
  return axios.default.post(
    `/mint.v1.CreditService/InfuseCredits`,
    v1InfuseCreditsRequest,
    options,
  );
};

export const getInfuseCreditsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof infuseCredits>>,
    TError,
    { data: V1InfuseCreditsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof infuseCredits>>,
  TError,
  { data: V1InfuseCreditsRequest },
  TContext
> => {
  const mutationKey = ['infuseCredits'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof infuseCredits>>,
    { data: V1InfuseCreditsRequest }
  > = props => {
    const { data } = props ?? {};

    return infuseCredits(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InfuseCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof infuseCredits>>
>;
export type InfuseCreditsMutationBody = V1InfuseCreditsRequest;
export type InfuseCreditsMutationError = AxiosError<RpcStatus>;

/**
 * @summary InfuseCredits adds credits to an Organization's balance.
Used when a customer purchases additional capacity.
 */
export const useInfuseCredits = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof infuseCredits>>,
      TError,
      { data: V1InfuseCreditsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof infuseCredits>>,
  TError,
  { data: V1InfuseCreditsRequest },
  TContext
> => {
  const mutationOptions = getInfuseCreditsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
